import { Injectable } from '@angular/core';
import { LogoutDialog } from '../pages/logout/logout-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { Location } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class ExitService {

  exit = false;

  constructor( private dialog: MatDialog, private auth: AuthService, private _location: Location ) { }

  logout() {
    const dialogRef = this.dialog.open(LogoutDialog);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.exit = true;
        this.auth.logout();
      }
    });
  }

  exitgame() {
    this.exit = true;
    this._location.back();
  }

}
